 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import LUFTWAFFEFIGHTERPILOT_FRONTCOVER from '@/components/LuftwaffeFighterPilot_frontcover'
 import LUFTWAFFEFIGHTERPILOT_TITLE from '@/components/LuftwaffeFighterPilot_title'
 import LUFTWAFFEFIGHTERPILOT_COPYRIGHT from '@/components/LuftwaffeFighterPilot_copyright'
 import LUFTWAFFEFIGHTERPILOT_TOC from '@/components/LuftwaffeFighterPilot_toc'
 import LUFTWAFFEFIGHTERPILOT_PREFACE from '@/components/LuftwaffeFighterPilot_preface'
 import LUFTWAFFEFIGHTERPILOT_FRONT from '@/components/LuftwaffeFighterPilot_front'
 import LUFTWAFFEFIGHTERPILOT_CH1 from '@/components/LuftwaffeFighterPilot_ch1'
 import LUFTWAFFEFIGHTERPILOT_CH101 from '@/components/LuftwaffeFighterPilot_ch101'
 import LUFTWAFFEFIGHTERPILOT_CH102 from '@/components/LuftwaffeFighterPilot_ch102'
 import LUFTWAFFEFIGHTERPILOT_CH2 from '@/components/LuftwaffeFighterPilot_ch2'
 import LUFTWAFFEFIGHTERPILOT_CH201 from '@/components/LuftwaffeFighterPilot_ch201'
 import LUFTWAFFEFIGHTERPILOT_CH202 from '@/components/LuftwaffeFighterPilot_ch202'
 import LUFTWAFFEFIGHTERPILOT_CH3 from '@/components/LuftwaffeFighterPilot_ch3'
 import LUFTWAFFEFIGHTERPILOT_CH301 from '@/components/LuftwaffeFighterPilot_ch301'
 import LUFTWAFFEFIGHTERPILOT_CH302 from '@/components/LuftwaffeFighterPilot_ch302'
 import LUFTWAFFEFIGHTERPILOT_CH4 from '@/components/LuftwaffeFighterPilot_ch4'
 import LUFTWAFFEFIGHTERPILOT_CH401 from '@/components/LuftwaffeFighterPilot_ch401'
 import LUFTWAFFEFIGHTERPILOT_CH402 from '@/components/LuftwaffeFighterPilot_ch402'
 import LUFTWAFFEFIGHTERPILOT_CH5 from '@/components/LuftwaffeFighterPilot_ch5'
 import LUFTWAFFEFIGHTERPILOT_CH501 from '@/components/LuftwaffeFighterPilot_ch501'
 import LUFTWAFFEFIGHTERPILOT_CH502 from '@/components/LuftwaffeFighterPilot_ch502'
 import LUFTWAFFEFIGHTERPILOT_CH503 from '@/components/LuftwaffeFighterPilot_ch503'
 import LUFTWAFFEFIGHTERPILOT_CH504 from '@/components/LuftwaffeFighterPilot_ch504'
 import LUFTWAFFEFIGHTERPILOT_CH505 from '@/components/LuftwaffeFighterPilot_ch505'
 import LUFTWAFFEFIGHTERPILOT_CH506 from '@/components/LuftwaffeFighterPilot_ch506'
 import LUFTWAFFEFIGHTERPILOT_CH507 from '@/components/LuftwaffeFighterPilot_ch507'
 import LUFTWAFFEFIGHTERPILOT_CH508 from '@/components/LuftwaffeFighterPilot_ch508'
 import LUFTWAFFEFIGHTERPILOT_CH509 from '@/components/LuftwaffeFighterPilot_ch509'
 import LUFTWAFFEFIGHTERPILOT_CH510 from '@/components/LuftwaffeFighterPilot_ch510'
 import LUFTWAFFEFIGHTERPILOT_CH511 from '@/components/LuftwaffeFighterPilot_ch511'
 import LUFTWAFFEFIGHTERPILOT_CH512 from '@/components/LuftwaffeFighterPilot_ch512'
 import LUFTWAFFEFIGHTERPILOT_CH513 from '@/components/LuftwaffeFighterPilot_ch513'
 import LUFTWAFFEFIGHTERPILOT_CH514 from '@/components/LuftwaffeFighterPilot_ch514'
 import LUFTWAFFEFIGHTERPILOT_CH515 from '@/components/LuftwaffeFighterPilot_ch515'
 import LUFTWAFFEFIGHTERPILOT_CH516 from '@/components/LuftwaffeFighterPilot_ch516'
 import LUFTWAFFEFIGHTERPILOT_CH517 from '@/components/LuftwaffeFighterPilot_ch517'
 import LUFTWAFFEFIGHTERPILOT_CH518 from '@/components/LuftwaffeFighterPilot_ch518'
 import LUFTWAFFEFIGHTERPILOT_CH519 from '@/components/LuftwaffeFighterPilot_ch519'
 import LUFTWAFFEFIGHTERPILOT_CH520 from '@/components/LuftwaffeFighterPilot_ch520'
 import LUFTWAFFEFIGHTERPILOT_CH521 from '@/components/LuftwaffeFighterPilot_ch521'
 import LUFTWAFFEFIGHTERPILOT_CH522 from '@/components/LuftwaffeFighterPilot_ch522'
 import LUFTWAFFEFIGHTERPILOT_CH523 from '@/components/LuftwaffeFighterPilot_ch523'
 import LUFTWAFFEFIGHTERPILOT_CH524 from '@/components/LuftwaffeFighterPilot_ch524'
 import LUFTWAFFEFIGHTERPILOT_CH525 from '@/components/LuftwaffeFighterPilot_ch525'
 import LUFTWAFFEFIGHTERPILOT_CH526 from '@/components/LuftwaffeFighterPilot_ch526'
 import LUFTWAFFEFIGHTERPILOT_CH527 from '@/components/LuftwaffeFighterPilot_ch527'
 import LUFTWAFFEFIGHTERPILOT_CH528 from '@/components/LuftwaffeFighterPilot_ch528'
 import LUFTWAFFEFIGHTERPILOT_CH529 from '@/components/LuftwaffeFighterPilot_ch529'
 import LUFTWAFFEFIGHTERPILOT_CH530 from '@/components/LuftwaffeFighterPilot_ch530'
 import LUFTWAFFEFIGHTERPILOT_CH531 from '@/components/LuftwaffeFighterPilot_ch531'
 import LUFTWAFFEFIGHTERPILOT_CH532 from '@/components/LuftwaffeFighterPilot_ch532'
 import LUFTWAFFEFIGHTERPILOT_CH533 from '@/components/LuftwaffeFighterPilot_ch533'
 import LUFTWAFFEFIGHTERPILOT_CH534 from '@/components/LuftwaffeFighterPilot_ch534'
 import LUFTWAFFEFIGHTERPILOT_CH535 from '@/components/LuftwaffeFighterPilot_ch535'
 import LUFTWAFFEFIGHTERPILOT_CH536 from '@/components/LuftwaffeFighterPilot_ch536'
 import LUFTWAFFEFIGHTERPILOT_CH537 from '@/components/LuftwaffeFighterPilot_ch537'
 import LUFTWAFFEFIGHTERPILOT_CH538 from '@/components/LuftwaffeFighterPilot_ch538'
 import LUFTWAFFEFIGHTERPILOT_CH539 from '@/components/LuftwaffeFighterPilot_ch539'
 import LUFTWAFFEFIGHTERPILOT_CH540 from '@/components/LuftwaffeFighterPilot_ch540'
 import LUFTWAFFEFIGHTERPILOT_CH541 from '@/components/LuftwaffeFighterPilot_ch541'
 import LUFTWAFFEFIGHTERPILOT_CH542 from '@/components/LuftwaffeFighterPilot_ch542'
 import LUFTWAFFEFIGHTERPILOT_CH543 from '@/components/LuftwaffeFighterPilot_ch543'
 import LUFTWAFFEFIGHTERPILOT_CH544 from '@/components/LuftwaffeFighterPilot_ch544'
 import LUFTWAFFEFIGHTERPILOT_CH545 from '@/components/LuftwaffeFighterPilot_ch545'
 import LUFTWAFFEFIGHTERPILOT_CH546 from '@/components/LuftwaffeFighterPilot_ch546'
 import LUFTWAFFEFIGHTERPILOT_CH547 from '@/components/LuftwaffeFighterPilot_ch547'
 import LUFTWAFFEFIGHTERPILOT_CH548 from '@/components/LuftwaffeFighterPilot_ch548'
 import LUFTWAFFEFIGHTERPILOT_CH549 from '@/components/LuftwaffeFighterPilot_ch549'
 import LUFTWAFFEFIGHTERPILOT_CH550 from '@/components/LuftwaffeFighterPilot_ch550'
 import LUFTWAFFEFIGHTERPILOT_CH551 from '@/components/LuftwaffeFighterPilot_ch551'
 import LUFTWAFFEFIGHTERPILOT_CH552 from '@/components/LuftwaffeFighterPilot_ch552'
 import LUFTWAFFEFIGHTERPILOT_CH553 from '@/components/LuftwaffeFighterPilot_ch553'
 import LUFTWAFFEFIGHTERPILOT_CH554 from '@/components/LuftwaffeFighterPilot_ch554'
 import LUFTWAFFEFIGHTERPILOT_CH555 from '@/components/LuftwaffeFighterPilot_ch555'
 import LUFTWAFFEFIGHTERPILOT_CH556 from '@/components/LuftwaffeFighterPilot_ch556'
 import LUFTWAFFEFIGHTERPILOT_CH557 from '@/components/LuftwaffeFighterPilot_ch557'
 import LUFTWAFFEFIGHTERPILOT_CH558 from '@/components/LuftwaffeFighterPilot_ch558'
 import LUFTWAFFEFIGHTERPILOT_CH559 from '@/components/LuftwaffeFighterPilot_ch559'
 import LUFTWAFFEFIGHTERPILOT_CH560 from '@/components/LuftwaffeFighterPilot_ch560'
 import LUFTWAFFEFIGHTERPILOT_CH561 from '@/components/LuftwaffeFighterPilot_ch561'
 import LUFTWAFFEFIGHTERPILOT_CH562 from '@/components/LuftwaffeFighterPilot_ch562'
 import LUFTWAFFEFIGHTERPILOT_CH563 from '@/components/LuftwaffeFighterPilot_ch563'
 import LUFTWAFFEFIGHTERPILOT_CH564 from '@/components/LuftwaffeFighterPilot_ch564'
 import LUFTWAFFEFIGHTERPILOT_CH565 from '@/components/LuftwaffeFighterPilot_ch565'
 import LUFTWAFFEFIGHTERPILOT_CH566 from '@/components/LuftwaffeFighterPilot_ch566'
 import LUFTWAFFEFIGHTERPILOT_CH567 from '@/components/LuftwaffeFighterPilot_ch567'
 import LUFTWAFFEFIGHTERPILOT_CH568 from '@/components/LuftwaffeFighterPilot_ch568'
 import LUFTWAFFEFIGHTERPILOT_CH569 from '@/components/LuftwaffeFighterPilot_ch569'
 import LUFTWAFFEFIGHTERPILOT_CH570 from '@/components/LuftwaffeFighterPilot_ch570'
 import LUFTWAFFEFIGHTERPILOT_CH6 from '@/components/LuftwaffeFighterPilot_ch6'
 import LUFTWAFFEFIGHTERPILOT_CH601 from '@/components/LuftwaffeFighterPilot_ch601'
 import LUFTWAFFEFIGHTERPILOT_CH602 from '@/components/LuftwaffeFighterPilot_ch602'
 import LUFTWAFFEFIGHTERPILOT_CH7 from '@/components/LuftwaffeFighterPilot_ch7'
 import LUFTWAFFEFIGHTERPILOT_CH8 from '@/components/LuftwaffeFighterPilot_ch8'
 import LUFTWAFFEFIGHTERPILOT_CH801 from '@/components/LuftwaffeFighterPilot_ch801'
 import LUFTWAFFEFIGHTERPILOT_CH802 from '@/components/LuftwaffeFighterPilot_ch802'
 import LUFTWAFFEFIGHTERPILOT_CH803 from '@/components/LuftwaffeFighterPilot_ch803'
 import LUFTWAFFEFIGHTERPILOT_CH804 from '@/components/LuftwaffeFighterPilot_ch804'
 import LUFTWAFFEFIGHTERPILOT_CH9 from '@/components/LuftwaffeFighterPilot_ch9'
 import LUFTWAFFEFIGHTERPILOT_CH901 from '@/components/LuftwaffeFighterPilot_ch901'
 import LUFTWAFFEFIGHTERPILOT_CH902 from '@/components/LuftwaffeFighterPilot_ch902'
 import LUFTWAFFEFIGHTERPILOT_APPENDIX1 from '@/components/LuftwaffeFighterPilot_appendix1'
 import LUFTWAFFEFIGHTERPILOT_APPENDIX2 from '@/components/LuftwaffeFighterPilot_appendix2'
 import LUFTWAFFEFIGHTERPILOT_APPENDIX3 from '@/components/LuftwaffeFighterPilot_appendix3'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_frontcover",
 			"name" : "LuftwaffeFighterPilot_frontcover",
 			"component" : LUFTWAFFEFIGHTERPILOT_FRONTCOVER
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_title",
 			"name" : "LuftwaffeFighterPilot_title",
 			"component" : LUFTWAFFEFIGHTERPILOT_TITLE
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_copyright",
 			"name" : "LuftwaffeFighterPilot_copyright",
 			"component" : LUFTWAFFEFIGHTERPILOT_COPYRIGHT
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_toc",
 			"name" : "LuftwaffeFighterPilot_toc",
 			"component" : LUFTWAFFEFIGHTERPILOT_TOC
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_preface",
 			"name" : "LuftwaffeFighterPilot_preface",
 			"component" : LUFTWAFFEFIGHTERPILOT_PREFACE
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_front",
 			"name" : "LuftwaffeFighterPilot_front",
 			"component" : LUFTWAFFEFIGHTERPILOT_FRONT
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_ch1",
 			"name" : "LuftwaffeFighterPilot_ch1",
 			"component" : LUFTWAFFEFIGHTERPILOT_CH1
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_ch101",
 			"name" : "LuftwaffeFighterPilot_ch101",
 			"component" : LUFTWAFFEFIGHTERPILOT_CH101
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_ch102",
 			"name" : "LuftwaffeFighterPilot_ch102",
 			"component" : LUFTWAFFEFIGHTERPILOT_CH102
 		},
 		{
 			"path" : "/LuftwaffeFighterPilot_ch2",
 			"name" : "LuftwaffeFighterPilot_ch2",
 			"component" : LUFTWAFFEFIGHTERPILOT_CH2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js